<div class="iguau-profile-visibility" *ngIf="!misdatos.user_new">
  <ng-container *ngIf="(errores$ | async) as listaErrores">
    <section class="ig-visibility-banner" *ngIf="soloConKey(listaErrores).length > 0" role="status" aria-live="polite">
      <span class="ig-visibility-icon" aria-hidden="true"><i class="fa-solid fa-circle-exclamation"></i></span>
      <div class="ig-visibility-main">
        <div class="ig-visibility-heading">
          <h2>Completa tu perfil para aparecer en iGuau</h2>
          <span class="ig-visibility-count">{{ soloConKey(listaErrores).length }} pendiente(s)</span>
        </div>
        <p>Faltan algunos datos para que otras personas puedan encontrarte y conectar contigo.</p>
        <ul class="ig-visibility-items">
          <li *ngFor="let err of soloConKey(listaErrores)"><i class="fa-solid fa-circle-dot" aria-hidden="true"></i><span [innerHTML]="err.mensaje"></span></li>
        </ul>
      </div>
    </section>
    <section class="ig-visibility-banner ig-visibility-success" *ngIf="soloSinKey(listaErrores).length > 0" role="status">
      <span class="ig-visibility-icon" aria-hidden="true"><i class="fa-solid fa-circle-check"></i></span>
      <div class="ig-visibility-main">
        <h2 [innerHTML]="listaErrores[0].mensaje"></h2>
        <p>Ya pueden encontrarte y conectar contigo en la comunidad.</p>
      </div>
    </section>
  </ng-container>
</div>
